<template>
  <v-container class="pa-0" fluid>
    <v-row cols="5" no-gutters style="min-height: 100vh">
      <v-col offset-xl="4" offset-md="3" class="d-flex align-center text-center pa-5 pa-sm-10" cols="12" md="6" xl="4">
        <v-card class="pa-5 pa-sm-10">
          <v-img
            contain
            :aspect-ratio="290 / 36.77"
            style="border-radius: 0"
            class="mx-auto mb-5"
            src="@/assets/logo.svg"
            max-width="290px"
          ></v-img>
          <h1 class="text-center mt-5 mb-8 fw-700 fs-18 primary-blue--text">
            Welcome to the 2022 ASCO Annual Meeting On Demand
          </h1>
          <v-form>
            <v-row>
              <v-col cols="12" lg="6">
                <text-field name="username" v-model="username" dense hide-details label="Username *" outlined />
              </v-col>
              <v-col cols="12" lg="6">
                <text-field
                  name="password"
                  v-model="password"
                  type="password"
                  dense
                  hide-details
                  label="Password *"
                  outlined
                />
              </v-col>
            </v-row>
            <v-row>
              <v-checkbox
                class="v-input--checkbox"
                dense
                label="I understand this is an educational web site for Healthcare Professionals, and that the site may include information on investigational uses of compounds that have not yet been approved by regulatory authorities"
                v-model="confirmUnderstand"
              />
            </v-row>
            <v-row>
              <v-checkbox class="v-input--checkbox" dense v-model="confirmDisclaimer">
                <template v-slot:label>
                  <span>
                    To access the ASCO22 Meeting Videos, Presentation Slides, Abstracts and Posters you confirm you have
                    read and agree to the
                    <a
                      target="_blank"
                      href="https://www.asco.org/about-asco/legal/terms-use"
                      class="primary-green--text"
                      >terms of use</a
                    >
                  </span>
                </template>
              </v-checkbox>
            </v-row>
            <!--            <v-row>-->
            <!--              <v-checkbox class="v-input&#45;&#45;checkbox" dense label="Keep me signed in" />-->
            <!--            </v-row>-->
            <v-row class="flex-column">
              <v-btn :loading="loading" :disabled="loading" @click="signIn" class="mx-auto" color="green"> Login</v-btn>
              <small v-if="!!error" class="mt-1 red--text" v-text="error" />
              <a class="mt-5" href="mailto:asco@springer.com">Need help logging in?</a>
            </v-row>
          </v-form>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { mapActions, mapState, mapMutations } from 'vuex';
import TextField from '@/components/common/TextField';

export default {
  name: 'Login',
  components: { TextField },
  data: () => {
    return {
      confirmUnderstand: false,
      confirmDisclaimer: false,
      username: '',
      password: ''
    };
  },
  computed: mapState('authentication', ['loading', 'isAuthenticated', 'error']),
  methods: {
    ...mapActions('authentication', {
      signInAction: 'signIn'
    }),
    ...mapMutations('authentication', ['setError']),
    async signIn() {
      if (!this.confirmUnderstand && !this.confirmDisclaimer) {
        return this.setError(
          'Using the checkbox above please confirm you understand this is an educational web site for Healthcare Professionals from outside the US and Canada, and that the site may include information on investigational uses of compounds that have not yet been approved by regulatory authorities'
        );
      } else if (!this.confirmUnderstand) {
        return this.setError(
          'Using the checkbox below please confirm you understand this is an educational web site for Healthcare Professionals from outside the US and Canada, and that the site may include information on investigational uses of compounds that have not yet been approved by regulatory authorities'
        );
      } else if (!this.confirmDisclaimer) {
        return this.setError(
          'Using the check box below please confirm that you have read and agree to the terms of use'
        );
      }
      await this.signInAction({
        username: this.username,
        password: this.password
      });
    }
  }
};
</script>

<style scoped>
.v-input--checkbox >>> .v-input__control > .v-input__slot {
  align-items: flex-start;
}
</style>
